export const app = "https://api.alaminapartments.com/api";
export const image = "https://api.alaminapartments.com/storage";
//export const app = "http://127.0.0.1:8000/api";
//export const image = "http://127.0.0.1:8000/storage";
export const appName = "Alamin Apartments";
export const motto = "Rental System";
export const dropboxToken = "";
